import { render, staticRenderFns } from "./AdditionalInstructionModal.vue?vue&type=template&id=c8c196c2"
import script from "./AdditionalInstructionModal.vue?vue&type=script&lang=js"
export * from "./AdditionalInstructionModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports